import React, { Component } from "react";
import { actions } from 'react-redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from "react-bootstrap";

import { InputFieldFloatingLabel as InputField, SelectFieldFloatingLabel} from "../../../../common/custom-form/select-filter.component";
import DATEPICKER_OR from "../../../../common/custom-form/custom-date-picker.component";
import { DATA_TYPE, MAX_LENGTH, ROUTE_LINK_LOCATION } from "../../../../../constants/external-constants";
import { TRANSLATIONS } from "../../../../../utils/constant.utils";
import { TabberButton } from "../../../../common/custom-form/tabber-button.component";
import UploadButton from "../../../../common/upload-button/upload-button";
import DetailsInfo from "../../../../common/modal/details-modal/details-info";
import { invoiceDetailsAction } from "../../../../../store/external/invoice/invoice/invoice-details.reducer";
import { InputAutoSuggest } from "../../../../common/custom-form/input-auto-suggest.component";
import DateRange from "../../../../common/custom-form/custom-date-range-component";
import { invoiceInvoiceActions } from "../../../../../store/external/invoice/invoice.reducer";
import { isObjectEqual } from "../../../../../utils/helpers.utils";
import { ConfirmationModal } from "../../../../common/modal/modal.component";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import { Loading } from "../../../../common/loading/index";
import Translation from "../../../../common/translation/translation.component";

import CustomSearchableSelectWrapper from "../../../../common/custom-form/custom-searchable-select-wrapper.component";
import CustomSearchableDropdownWrapper from "../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";
import { ChatbotActions } from "../../../../../store/common/chatbot/chatbot.reducer";

class InvoiceForm extends Component{
    constructor(props) {
        super(props);

        this.state = {
            saveModal: {
                title: "",
                messageBody: "",
                isLoading: true,
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            isSaving: false,
            exportAlertMsg: "",
        };

        this.BillingAccountNumberAutoSuggest = React.createRef();
        this.SubAccountNumberAutoSuggest = React.createRef();
        this.AssignedUserAutoSuggest = React.createRef();
        this.ConfirmationModal = React.createRef();
        this.UploadButton = React.createRef();
        this.TabberButton = React.createRef();
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
        const { invoiceDetailsId, getInvoiceDetailsForm } = this.props;

        this.props.getInvoiceDetail(invoiceDetailsId, true);

        if (invoiceDetailsId) {
            var data = await getInvoiceDetailsForm(invoiceDetailsId);

            if (data) {
                if (this.BillingAccountNumberAutoSuggest.current) {
                    this.BillingAccountNumberAutoSuggest.current.onChange(null, { newValue: data.BillingAccountNumber?.AccountNumber ?? '' });
                }
                if (this.SubAccountNumberAutoSuggest.current) {
                    this.SubAccountNumberAutoSuggest.current.onChange(null, { newValue: data.SubAccountNumber?.Value ?? '' });
                }
                if (this.AssignedUserAutoSuggest.current) {
                    this.AssignedUserAutoSuggest.current.onChange(null, { newValue: data.AssignedUser.Value ?? '' });
                }
                if (this.UploadButton.current) {
                    this.UploadButton.current.setUploadFileName(data.InvoicePDF ?? '');
                }
                if (this.TabberButton.current) {
                    this.TabberButton.current.toggle(data.CreditNote ?? false);
                }
                this.fetchInvoiceData();
            }
        }        
    }

    fetchInvoiceData = async () => {
        const {
            getBillingAccounts,
            getSubAccounts,
            getAssignedUsers,
            isCreateNew,
            invoiceId,
            getInvoiceFormDetails
        } = this.props;

        const { billingAccountNumberDisplay, subAccountNumberDisplay, assignedUserDisplay } = this.props.invoiceInvoiceDetailsForm;

        // If editing an existing invoice, load its details
        if (!isCreateNew && invoiceId > 0) {
            await getInvoiceFormDetails(invoiceId).then(() => {
                this.setState({ isLoading: false });
            });
        }

        // Fetch dropdowns
        await getBillingAccounts(1, billingAccountNumberDisplay);
        await getSubAccounts(1, subAccountNumberDisplay);
        await getAssignedUsers(1, assignedUserDisplay);

        this.setState({ isLoading: false });
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props.translation;
        if (locale === null || locale === '')
            return TRANSLATIONS[TRANSLATIONS['defaultLocaleLanguage']][key];

        return TRANSLATIONS[locale][key];
    }

    onChangeBillingPeriod = (dates) => {
        const [start, end] = dates;

        this.props.FormChange('invoiceInvoiceDetailsForm.billingPeriodFrom', start);
        this.props.FormChange('invoiceInvoiceDetailsForm.billingPeriodTo', end);
    };

    onChangeRentalPeriod = (dates) => {
        const [start, end] = dates;

        this.props.FormChange('invoiceInvoiceDetailsForm.rentalPeriodFrom', start);
        this.props.FormChange('invoiceInvoiceDetailsForm.rentalPeriodTo', end);
    };

    handleGetAccountDetail = (billingAccountID) => {
        const { getInvoiceAccountDetailsModal, getInvoiceAccountCostAllocationModal, getAccountLinkedInvoice } = this.props
        getInvoiceAccountDetailsModal(billingAccountID)
        getInvoiceAccountCostAllocationModal(billingAccountID)
        getAccountLinkedInvoice(billingAccountID)
    }

    disableSaveChanges = () => {
        const { invoiceInvoiceDetails, invoiceInvoiceDetailsForm, $form } = this.props;

        let disabled = !invoiceInvoiceDetailsForm.billingAccountNumberId
            || !invoiceInvoiceDetailsForm.invoiceNumber
            || !invoiceInvoiceDetailsForm.status
            || !invoiceInvoiceDetailsForm.invoiceDate
            || !invoiceInvoiceDetailsForm.invoiceExpectedDate
            || !invoiceInvoiceDetailsForm.invoiceDueDate
            || !invoiceInvoiceDetailsForm.billingPeriodFrom
            || !invoiceInvoiceDetailsForm.billingPeriodTo
            || !invoiceInvoiceDetailsForm.rentalPeriodFrom
            || !invoiceInvoiceDetailsForm.rentalPeriodTo
            || !invoiceInvoiceDetailsForm.assignedUserId
            || !invoiceInvoiceDetailsForm.totalAmountDue;

        if (invoiceInvoiceDetails.isInvoiceApprovedDateRequired) {
            disabled = disabled || !invoiceInvoiceDetailsForm.invoiceApprovedDate;
        }

        const unchanged = isObjectEqual($form.loadedValue, invoiceInvoiceDetailsForm);

        return disabled || unchanged;
    }

    handleSaveInvoice = async (invoiceId, validate = true) => {
        const { saveInvoiceForm, getInvoiceDetailsForm, invoiceInvoiceDetailsForm } = this.props;

        this.setState({
            isSaving: true
        });

        var invoiceFile = this.UploadButton.current.inputFileValue();
        var result = await saveInvoiceForm(invoiceId, validate, invoiceFile);
        this.setState({
            isSaving: false
        });

        if (result.success) {
            if (result.isValid) {
                const confirmMessage = "Are you sure you want to update?";
                const modalTitle = this.toLocaleLanguage("call_save");
                var confirmAction = () => this.handleSaveInvoice(invoiceInvoiceDetailsForm.id, false);
                this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                return;
            }
            else {
                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, this.toLocaleLanguage("success_modal_title"), result.message);

                const responseData = result.data;
                var formData = await getInvoiceDetailsForm(responseData.invoiceId);

                if (formData) {
                    if (this.BillingAccountNumberAutoSuggest.current) {
                        this.BillingAccountNumberAutoSuggest.current.onChange(null, { newValue: formData.BillingAccountNumber?.AccountNumber ?? '' });
                    }
                    if (this.SubAccountNumberAutoSuggest.current) {
                        this.SubAccountNumberAutoSuggest.current.onChange(null, { newValue: formData.SubAccountNumber?.Value ?? '' });
                    }
                    if (this.AssignedUserAutoSuggest.current) {
                        this.AssignedUserAutoSuggest.current.onChange(null, { newValue: formData.AssignedUser?.Value ?? '' });
                    }
                    if (this.UploadButton.current) {
                        this.UploadButton.current.setUploadFileName(formData.InvoicePDF ?? '');
                    }
                    if (this.TabberButton.current) {
                        this.TabberButton.current.toggle(formData.CreditNote ?? false);
                    }
                }
            }
        }
        else {
            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title"), result.message);
            return;
        }
    }

    handleDeleteInvoice = async (invoiceId, validate = true) => {
        const { deleteInvoiceForm, invoiceInvoiceDetailsForm } = this.props;

        this.setState({
            isSaving: true
        });

        if(validate){

            this.setState({
                isSaving: false
            });

            const confirmMessage = this.toLocaleLanguage("modal_invoice_delete_message");
            const modalTitle = this.toLocaleLanguage("modal_invoice_delete_title");
            var confirmAction = () => this.handleDeleteInvoice(invoiceInvoiceDetailsForm.id, false);
            this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
            return;
        }

        var result = await deleteInvoiceForm(invoiceId);
        this.setState({
            isSaving: false
        });

        if (result.success) {
            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, this.toLocaleLanguage("success_modal_title"), this.toLocaleLanguage("modal_invoice_delete_success"));
            return;
        }
        else {
            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title"), this.toLocaleLanguage("modal_invoice_delete_fail"));
            return;
        }
    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif } = this.state;
        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });

        if (!isShow && saveNotif.message === this.toLocaleLanguage("modal_invoice_delete_success")) {
            this.props.handlecloseForm();
        }
    }

    convertToDecimal = (value) => {
        if (typeof value === "string") return value;

        const result = (Math.round(value * 100) / 100).toFixed(2);

        return result;
    }

    onClickExtract = (e) => {
        const { id, invoiceAttachmentId, invoicePDF } = this.props.invoiceInvoiceDetailsForm;
        const { downloadInvoiceFile } = this.props;

        if (window.confirm(this.state.extractAlertMsg)) {
            downloadInvoiceFile(id, invoiceAttachmentId, invoicePDF );
        }
    };

    onChangeExtractAlertMsg = (val, key) => {
        this.setState({
            extractAlertMsg: val
        });
    }

    onChangeActionBillingAccountNumber = (value, propsName) => {
        const { onChangeBillingAccountNumber } = this.props;
        onChangeBillingAccountNumber(value, propsName);

        if (this.SubAccountNumberAutoSuggest.current) {
            this.SubAccountNumberAutoSuggest.current.onChange(null, { newValue: '' });
        }
    }

    // Billing Accounts
    loadMoreBillingAccounts = (searchString) => {
        const { invoiceInvoiceDetails } = this.props;
        this.props.getBillingAccounts(invoiceInvoiceDetails.billingAccountsPage + 1, searchString);
    }

    handleSearchBillingAccounts = (query) => {
        this.props.getBillingAccounts(1, query);
    }

    // Sub Accounts
    loadMoreSubAccounts = (searchString) => {
        const { invoiceInvoiceDetails } = this.props;
        this.props.getSubAccounts(invoiceInvoiceDetails.subAccountsPage + 1, searchString);
    }

    handleSearchSubAccounts = (query) => {
        this.props.getSubAccounts(1, query);
    }

    // Assigned Users
    loadMoreAssignedUsers = (searchString) => {
        const { invoiceInvoiceDetails } = this.props;
        this.props.getAssignedUsers(invoiceInvoiceDetails.assignedUsersPage + 1, searchString);
    }

    handleSearchAssignedUsers = (query) => {
        this.props.getAssignedUsers(1, query);
    }

    render() {
        const {
            searchBillingAccountNumber,
            onChangeStatus,
            onChangeSubAccountNumber,
            searchSubAccountNumber,
            onChangeAssignedUser,
            onChangeBillingAccountNumber,
            searchAssignedUser
        } = this.props;
        const { invoiceInvoiceDetailsForm, invoiceInvoiceDetails, invoiceInvoice, setAccountLinkedInvoiceSearchValue, isReadAndWrite } = this.props;

        return (
            <>
                <Translation
                    getOnlyText={true}
                    onChangeTranslation={this.onChangeExtractAlertMsg}
                    translationKey={"export_alert_message"} />
                {
                    invoiceInvoiceDetails.fetchFormInProgress ?
                        <Loading />
                        :
                        <>
                            <div className="details-container details-field-container mb-3 invoice-detail-container">
                                <div className="detail-with-icon-container">
                                    {
                                        invoiceInvoiceDetailsForm.billingAccountNumberId > 0 &&

                                        <DetailsInfo
                                            title="Account Details"
                                            linkedTitle="linked_invoices_capital"
                                            getAccountDetail={this.handleGetAccountDetail}
                                            valueselected={invoiceInvoiceDetailsForm.billingAccountNumberId}
                                            locale={this.props.translation.locale}
                                            detailsInfo={invoiceInvoice.invoiceAccountDetails}

                                            //search
                                            setSearchValue={setAccountLinkedInvoiceSearchValue}
                                            searchPlaceHolder={this.toLocaleLanguage('search_invoice')}

                                            //Cost Allocation
                                            Headers={invoiceInvoice.invoiceAccountCostAllocationModal.Headers}
                                            costAlloData={invoiceInvoice.invoiceAccountCostAllocationModal.Data}

                                            //Linked Circuit
                                            linkedHeaders={invoiceInvoice.invoiceAccountLinkedInvoice.Headers}
                                            linkedData={invoiceInvoice.invoiceAccountLinkedInvoice.Data}
                                            linkedPages={invoiceInvoice.invoiceAccountLinkedInvoice.Pagination}
                                            totalEntries={invoiceInvoice.invoiceAccountLinkedInvoiceTable.Pagination.TotalEntries}
                                            getAccountLinked={this.props.getAccountLinkedInvoice}
                                            routeLocation={ROUTE_LINK_LOCATION.invoiceRouteLink}
                                        />
                                    }                          
                                    <CustomSearchableDropdownWrapper
                                        label={`${this.toLocaleLanguage('billing_account_num')}`}
                                        options={invoiceInvoiceDetails.billingAccountNumberDropdown}
                                        selected={invoiceInvoiceDetails.billingAccountNumberDropdown.length > 0 ?
                                            invoiceInvoiceDetailsForm.billingAccountNumberId : null}
                                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                        onChange={onChangeBillingAccountNumber}
                                        requiredField
                                        fieldProp='invoiceInvoiceDetailsForm.billingAccountNumberId'
                                        tagName='billingAccountNumberDisplay'
                                        //tagName='Id'
                                        optionLabelKey={{
                                            Key: 'Id',
                                            Value: 'AccountNumber'
                                        }}
                                        maxLength={MAX_LENGTH.limit_255}
                                        onSearchChange={this.handleSearchBillingAccounts}
                                        onLoadMore={this.loadMoreBillingAccounts}
                                        isLoading={!invoiceInvoiceDetails.isBillingAccountDropdownLoaded}
                                        hasMore={invoiceInvoiceDetails.hasMoreBillingAccounts}
                                    />
                                </div>
                                <CustomSearchableDropdownWrapper
                                    label={`${this.toLocaleLanguage('sub_account_num')}`}
                                    options={invoiceInvoiceDetails.subAccountNumberDropdown}
                                    selected={invoiceInvoiceDetails?.subAccountNumberDropdown?.length > 0 ?
                                        invoiceInvoiceDetailsForm.subAccountNumberId : 0}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    onChange={onChangeSubAccountNumber}
                                    fieldProp='invoiceInvoiceDetailsForm.subAccountNumberId'
                                    tagName='subAccountNumberDisplay'
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value'
                                    }}
                                    maxLength={MAX_LENGTH.limit_255}
                                    //onSearchChange={this.handleSearchSubAccounts}
                                    onLoadMore={this.loadMoreSubAccounts}
                                    isLoading={invoiceInvoiceDetails.isSubAccountDropdownLoaded}
                                    hasMore={invoiceInvoiceDetails.hasMoreSubAccounts}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('client')}`}
                                    value={invoiceInvoiceDetailsForm.client}
                                    fieldProp='invoiceInvoiceDetailsForm.client'
                                    maxLength={MAX_LENGTH.limit_255}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('vendor')}`}
                                    value={invoiceInvoiceDetailsForm.vendor}
                                    fieldProp='invoiceInvoiceDetailsForm.vendor'
                                    maxLength={MAX_LENGTH.limit_255}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control required"
                                    type="text"
                                    label={`${this.toLocaleLanguage('invoice_number')}`}
                                    value={invoiceInvoiceDetailsForm.invoiceNumber}
                                    fieldProp='invoiceInvoiceDetailsForm.invoiceNumber'
                                    maxLength={MAX_LENGTH.limit_255}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                />
                                <SelectFieldFloatingLabel
                                    className="form-select required"
                                    label={`${this.toLocaleLanguage('status')}`}
                                    options={invoiceInvoiceDetails.statusDropdown}
                                    value={invoiceInvoiceDetailsForm.status ?? ""}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    isError={false}
                                    fieldProp='invoiceInvoiceDetailsForm.status'
                                    onChangeAction={onChangeStatus}
                                    optionLabelKey={{
                                        Key: "Key",
                                        Value: "Value"
                                    }}
                                />

                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('currency_capital')}`}
                                    value={invoiceInvoiceDetailsForm.currency}
                                    fieldProp='invoiceInvoiceDetailsForm.currency'
                                    maxLength={MAX_LENGTH.limit_255}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('exchange_rate')}`}
                                    value={invoiceInvoiceDetailsForm.exchangeRate}
                                    fieldProp='invoiceInvoiceDetailsForm.exchangeRate'
                                    maxLength={MAX_LENGTH.limit_255}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <div className="date-picker-main-container">
                                    <DATEPICKER_OR
                                        label={`${this.toLocaleLanguage('invoice_date')}`}
                                        dateOnly={true}
                                        startDate={invoiceInvoiceDetailsForm.invoiceDate}
                                        selectedDate={(date) => this.props.FormChange("invoiceInvoiceDetailsForm.invoiceDate", date)}
                                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                        requiredField={true}
                                    />
                                </div>

                                <div className="date-picker-main-container">
                                    <DATEPICKER_OR
                                        label={`${this.toLocaleLanguage('actual_invoice_month')}`}
                                        dateOnly={true}
                                        startDate={invoiceInvoiceDetailsForm.actualInvoiceMonth}
                                        selectedDate={(date) => this.props.FormChange("invoiceInvoiceDetailsForm.actualInvoiceMonth", date)}
                                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                        dateFormat="MMMM yyyy"
                                    />
                                </div>
                                <div className="date-picker-main-container">
                                    <DATEPICKER_OR
                                        label={`${this.toLocaleLanguage('invoice_expected_date')}`}
                                        dateOnly={true}
                                        startDate={invoiceInvoiceDetailsForm.invoiceExpectedDate}
                                        selectedDate={(date) => this.props.FormChange("invoiceInvoiceDetailsForm.invoiceExpectedDate", date)}
                                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                        requiredField={true}
                                    />
                                </div>
                                <div className="date-picker-main-container">
                                    <DATEPICKER_OR
                                        label={`${this.toLocaleLanguage('invoice_due_date')}`}
                                        dateOnly={true}
                                        startDate={invoiceInvoiceDetailsForm.invoiceDueDate}
                                        selectedDate={(date) => this.props.FormChange("invoiceInvoiceDetailsForm.invoiceDueDate", date)}
                                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                        requiredField={true}
                                    />
                                </div>
                                <div className="date-picker-main-container">
                                    <DATEPICKER_OR
                                        label={`${this.toLocaleLanguage('invoice_approve_date')}`}
                                        dateOnly={true}
                                        startDate={invoiceInvoiceDetailsForm.invoiceApprovedDate}
                                        selectedDate={(date) => this.props.FormChange("invoiceInvoiceDetailsForm.invoiceApprovedDate", date)}
                                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                        requiredField={invoiceInvoiceDetails.isInvoiceApprovedDateRequired}
                                    />
                                </div>
                                <div className="date-picker-main-container">
                                    <DateRange
                                        dateOnly={true}
                                        label={`${this.toLocaleLanguage('billing_period')}`}
                                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                        startDate={invoiceInvoiceDetailsForm.billingPeriodFrom}
                                        endDate={invoiceInvoiceDetailsForm.billingPeriodTo}
                                        dateSelected={invoiceInvoiceDetailsForm.billingPeriodFrom}
                                        onChange={this.onChangeBillingPeriod}
                                        requiredField={true}
                                    />
                                </div>
                                <div className="date-picker-main-container">
                                    <DateRange
                                        dateOnly={true}
                                        label={`${this.toLocaleLanguage('rental_period')}`}
                                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                        startDate={invoiceInvoiceDetailsForm.rentalPeriodFrom}
                                        endDate={invoiceInvoiceDetailsForm.rentalPeriodTo}
                                        dateSelected={invoiceInvoiceDetailsForm.rentalPeriodFrom}
                                        onChange={this.onChangeRentalPeriod}
                                        requiredField={true}
                                    />
                                </div>
                                <div className="date-picker-main-container">
                                    <DATEPICKER_OR
                                        label={`${this.toLocaleLanguage('invoice_receipt_date')}`}
                                        dateOnly={true}
                                        startDate={invoiceInvoiceDetailsForm.invoiceReceiptDate}
                                        selectedDate={(date) => this.props.FormChange("invoiceInvoiceDetailsForm.invoiceReceiptDate", date)}
                                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    />
                                </div>
                                <CustomSearchableDropdownWrapper
                                    label={`${this.toLocaleLanguage('assigned_user')}`}
                                    options={invoiceInvoiceDetails.assignedUserDropdown}
                                    selected={invoiceInvoiceDetails.assignedUserDropdown.length > 0 ?
                                        invoiceInvoiceDetailsForm.assignedUserId : null}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    onChange={onChangeAssignedUser}
                                    requiredField
                                    fieldProp='invoiceInvoiceDetailsForm.assignedUserId'
                                    tagName='assignedUserDisplay'
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value'
                                    }}
                                    maxLength={MAX_LENGTH.limit_255}
                                    onSearchChange={this.handleSearchAssignedUsers}
                                    onLoadMore={this.loadMoreAssignedUsers}
                                    isLoading={!invoiceInvoiceDetails.isAssignedUserDropdownLoaded}
                                    hasMore={invoiceInvoiceDetails.hasMoreAssignedUsers}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('edi_number')}`}
                                    value={invoiceInvoiceDetailsForm.ediNumber}
                                    fieldProp='invoiceInvoiceDetailsForm.ediNumber'
                                    maxLength={MAX_LENGTH.limit_255}
                                    placeholder={""}
                                />
                                <div className="date-picker-main-container">
                                    <DATEPICKER_OR
                                        dateOnly={true}
                                        label={`${this.toLocaleLanguage('upload_date')}`}
                                        startDate={invoiceInvoiceDetailsForm.uploadDate}
                                        selectedDate={(date) => this.props.FormChange("invoiceInvoiceDetailsForm.uploadDate", date)}
                                        isDisable={true}
                                    />
                                </div>
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('uploaded_by')}`}
                                    value={invoiceInvoiceDetailsForm.uploadedBy}
                                    fieldProp='invoiceInvoiceDetailsForm.uploadedBy'
                                    maxLength={MAX_LENGTH.limit_255}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <div className="tabber-form-container">
                                    <TabberButton ref={this.TabberButton} title="credit note" onToggle={(isActive) => this.props.FormChange("invoiceInvoiceDetailsForm.creditNote", isActive)} />
                                </div>
                                
                                <UploadButton
                                    ref={this.UploadButton}
                                    onChange={(fileName) => this.props.FormChange("invoiceInvoiceDetailsForm.invoicePDF", fileName)}
                                    onClickExtract={this.onClickExtract}
                                    title={"Invoice PDF"}
                                    {...this.props.roles}
                                />
                             
                                <div className="horizontal-separator additional-textarea-info"></div>
                                <InputField
                                    className="form-control required"
                                    type="text"
                                    label={`${this.toLocaleLanguage('total_amount_due')}`}
                                    value={this.convertToDecimal(invoiceInvoiceDetailsForm.totalAmountDue)}
                                    fieldProp='invoiceInvoiceDetailsForm.totalAmountDue'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                    inputType={DATA_TYPE.decimal}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('total_amount_to_pay')}`}
                                    value={invoiceInvoiceDetailsForm.totalAmountDue}
                                    fieldProp='invoiceInvoiceDetailsForm.totalAmountToPay'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('gross_amount')}`}
                                    value={invoiceInvoiceDetailsForm.grossAmount}
                                    fieldProp='invoiceInvoiceDetailsForm.grossAmount'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('no_charged_subscription')}`}
                                    value={invoiceInvoiceDetailsForm.noOfChargedSubscription}
                                    fieldProp='invoiceInvoiceDetailsForm.noOfChargedSubscription'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('remaining_balance')}`}
                                    value={invoiceInvoiceDetailsForm.remainingBalance}
                                    fieldProp='invoiceInvoiceDetailsForm.remainingBalance'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                    inputType={DATA_TYPE.decimal}
                                   
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('total_taxes')}`}
                                    value={invoiceInvoiceDetailsForm.totalTaxes}
                                    fieldProp='invoiceInvoiceDetailsForm.totalTaxes'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('total_net')}`}
                                    value={invoiceInvoiceDetailsForm.totalNet}
                                    fieldProp='invoiceInvoiceDetailsForm.totalNet'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('line_items_total')}`}
                                    value={invoiceInvoiceDetailsForm.lineItemsTotal}
                                    fieldProp='invoiceInvoiceDetailsForm.lineItemsTotal'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('account_level_charges')}`}
                                    value={invoiceInvoiceDetailsForm.accountLevelCharges}
                                    fieldProp='invoiceInvoiceDetailsForm.accountLevelCharges'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('usage_charges')}`}
                                    value={invoiceInvoiceDetailsForm.usageCharges}
                                    fieldProp='invoiceInvoiceDetailsForm.usageCharges'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('recurring_charges')}`}
                                    value={invoiceInvoiceDetailsForm.recurringCharges}
                                    fieldProp='invoiceInvoiceDetailsForm.recurringCharges'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('miscellaneous_charges')}`}
                                    value={invoiceInvoiceDetailsForm.miscellaneousCharges}
                                    fieldProp='invoiceInvoiceDetailsForm.miscellaneousCharges'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('payments')}`}
                                    value={this.convertToDecimal(invoiceInvoiceDetailsForm.payments)}
                                    fieldProp='invoiceInvoiceDetailsForm.payments'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                    inputType={DATA_TYPE.decimal}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('late_payment_fees')}`}
                                    value={this.convertToDecimal(invoiceInvoiceDetailsForm.latePaymentFees)}
                                    fieldProp='invoiceInvoiceDetailsForm.latePaymentFees'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                    inputType={DATA_TYPE.decimal}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('other_charges')}`}
                                    value={this.convertToDecimal(invoiceInvoiceDetailsForm.otherCharges)}
                                    fieldProp='invoiceInvoiceDetailsForm.otherCharges'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                    inputType={DATA_TYPE.decimal}
                                />
                                <div>

                                </div>
                                <div className="horizontal-separator additional-textarea-info"></div>
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('check')}`}
                                    value={invoiceInvoiceDetailsForm.checkNumber}
                                    fieldProp='invoiceInvoiceDetailsForm.checkNumber'
                                    maxLength={MAX_LENGTH.limit_255}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('amount_paid')}`}
                                    value={this.convertToDecimal(invoiceInvoiceDetailsForm.amountPaid)}
                                    fieldProp='invoiceInvoiceDetailsForm.amountPaid'
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                    inputType={DATA_TYPE.decimal}
                                />
                                <div className="date-picker-main-container">
                                    <DATEPICKER_OR
                                        label={`${this.toLocaleLanguage('payment_date')}`}
                                        dateOnly={true}
                                        startDate={invoiceInvoiceDetailsForm.paymentDate}
                                        selectedDate={(date) => this.props.FormChange("invoiceInvoiceDetailsForm.paymentDate", date)}
                                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    />
                                </div>
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('remit_id_capital')}`}
                                    value={invoiceInvoiceDetailsForm.remitId}
                                    fieldProp='invoiceInvoiceDetailsForm.remitId'
                                    maxLength={MAX_LENGTH.limit_255}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('ap_vendor_id_capital')}`}
                                    value={invoiceInvoiceDetailsForm.apVendorId}
                                    fieldProp='invoiceInvoiceDetailsForm.apVendorId'
                                    maxLength={MAX_LENGTH.limit_255}
                                    placeholder={""}
                                    disabled={true}
                                />
                            </div>
                            <div>
                                <ConfirmationModal
                                    ref={this.ConfirmationModal}
                                    title={this.state.saveModal.title}
                                    messageBody={this.state.saveModal.messageBody}
                                    confirmAction={this.state.saveModal.confirmAction}
                                    closeLabel={this.toLocaleLanguage("cancel_button")}
                                    confirmLabel={this.toLocaleLanguage("yes_button")}
                                    disabled={this.state.isSaving}
                                />

                                <NotificationModal
                                    show={this.state.saveNotif.show}
                                    title={this.state.saveNotif.title}
                                    message={this.state.saveNotif.message}
                                    handleModal={() => this.toggleSaveNotif(false)}
                                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                                />
                            </div>
                            <div className='save-btn-container justify-content-between'>
                                
                                { isReadAndWrite &&
                                    <Button className='delete-details-btn btn btn-danger'
                                        disabled={false}
                                        onClick={() => this.handleDeleteInvoice(invoiceInvoiceDetailsForm.id)}
                                        type='submit'>
                                        {this.toLocaleLanguage("delete_invoice_button")}
                                    </Button>
                                }

                                { isReadAndWrite &&
                                    <Button className='save-details-btn btn btn-primary'
                                        disabled={this.disableSaveChanges()}
                                        onClick={() => this.handleSaveInvoice(invoiceInvoiceDetailsForm.id)}
                                        type='submit'>
                                        {this.toLocaleLanguage("save_changes")}
                                    </Button>
                                }
                            </div>
                        </>
                }
            </>
        )
    }
}

export default connect(
    state => {
        const { translation,
            invoiceInvoice,
            invoiceInvoiceDetails,
            form: { invoiceInvoiceDetailsForm },
            form: { forms: { invoiceInvoiceDetailsForm: { $form } } }
        } = state;
       
        return {           
            translation,
            invoiceInvoiceDetails,
            invoiceInvoiceDetailsForm,
            invoiceInvoice,
            $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}
            ,invoiceDetailsAction
            , invoiceInvoiceActions
            , ChatbotActions)
            ,dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(InvoiceForm)